"use strict";

exports.__esModule = true;
exports.shouldForwardProp = void 0;

var _isStyleProp = require("./isStyleProp");

const props = new Set([..._isStyleProp.systemProps, 'as', 'size', 'sx', 'theme', 'variant']);

const shouldForwardProp = prop => !props.has(prop);

exports.shouldForwardProp = shouldForwardProp;